import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import React from 'react';
import { PRIORITY, TEAM } from './constants';
import { DefaultFallback } from './DefaultFallback';
import { Fallback } from './Fallback';

type ErrorBoundaryProps = {
  children: React.ReactNode;
  priority?: (typeof PRIORITY)[keyof typeof PRIORITY];
  team?: (typeof TEAM)[keyof typeof TEAM];
  useDefaultFallback?: boolean;
};

const ErrorBoundary = ({
  children,
  priority = PRIORITY.P0,
  team = TEAM.PAAR,
  useDefaultFallback,
}: ErrorBoundaryProps) => {
  return (
    <SentryErrorBoundary
      fallback={useDefaultFallback ? DefaultFallback : Fallback}
      beforeCapture={scope => {
        scope.setTag('priority', priority);
        scope.setTag('team', team);
      }}
    >
      {children}
    </SentryErrorBoundary>
  );
};

export { ErrorBoundary };
